export default "__VITE_ASSET__CRbiULXi__"